import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl } from '../../../lib/ep.js';

import { SquaredButton } from '../../builder/ActionButton';
import ButtonCollection from '../../builder/ButtonCollection';
import FloatingLayer from '../../builder/FloatingLayer';
import SectionTitle from '../../builder/SectionTitle';
import Select from '../../builder/Select';
import { SuccessMessage } from '../../builder/Message';
import Tooltip from '../../builder/Tooltip';
import Model from '../../builder/Model.js';

const DownloadFileOptions = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const downloads = props?.downloads ?? [];

	const [ model, setModel ] = useState({ col_separator:'tab' });
	const [ to_queue, setToQueue ] = useState(false);

	const col_separator_options = [
		{ k:'tab', v:"Tabulation" },
		{ k:'semicolon', v:"Semi-colon" },
		{ k:'colon', v:"Comma" },
	];

	const change = (k, v) => {
		setModel({ ...model, [k]:v });
	};

	const onclick = (url, utf8, csv) => {
		if(!url) return;

		const gets = [];
		if(utf8) gets.push('utf8=true');
		if(csv) gets.push('csv=true');

		if(gets.length > 0) {
			url += `${(url.indexOf("?") != -1) ? "&" : "?"}${gets.join("&")}`;
		}

		const data = {
			delimiter:model.col_separator,
		};

		$.post(url, data, (res) => {
			if(!res.status) {
				alert("Error 1");
				return;
			}

			$.post(url, data, (res_2) => {
				if(!res_2.status) {
					alert("Error 2");
					return;
				}

				if(res_2.status == 'mandrill') {
					setToQueue(res_2.email);
					return;
				}

				window.location.href = res_2?.url ?? res.url;
			}, 'JSON');
		}, 'JSON');
	};

	let has_xls = false;
	let has_csv = false;
	for(let i in downloads) {
		if(!has_xls) has_xls = downloads[i]?.xls?.enabled ?? false;
		if(!has_csv) has_csv = downloads[i]?.csv?.enabled ?? false;
	}

	if(to_queue) {
		return (
			<FloatingLayer
				backButton={() => props.close()}
			>
				<div class="without_actions">
					<SectionTitle>Export and download</SectionTitle>

					<SuccessMessage
						_class={{ other:'in_top in_bottom' }}
						title="In process"
					>
						<p>{i18n("Your request has been queued. The task can take some minutes.")}</p>

						<p>{i18n("When the job is complete, you will receive an email with a link to download the information requested to the following address")}: {to_queue}</p>

						<p>{i18n("Note: please, check your spam folder if you don't receive the email in the next 10 minutes.")}</p>
					</SuccessMessage>
				</div>
			</FloatingLayer>
		)
	}

	return (
		<FloatingLayer
			backButton={() => props.close()}
			_class={{ size:'small' }}
		>
			<div class="without_actions">
				<SectionTitle>Export and download</SectionTitle>

				<div>
					<Model
						model={model}
						change={change}
					>
						<Select
							name='col_separator'
							_class={{ first:true, size:40 }}
							values={col_separator_options}
						>Columns are delimited by</Select>
					</Model>

					<table
						class="gui_list_table gui_not_in_top_big"
						style={{ width:'100%' }}
						cellSpacing={0}
						cellPadding={0}
					>
						<thead>
							<tr class="list_header">
								<th />

								{(has_xls) && (
									<th class="gui_center_aligned">
										<strong>{i18n("XLS")}</strong>
									</th>
								)}

								{(has_csv) && (
									<th class="gui_center_aligned">
										<strong>{i18n("CSV")}</strong>
									</th>
								)}
							</tr>
						</thead>

						<tbody>
							{downloads.map((download, i) => {
								return (
									<tr key={i}>
										<td>
											<strong class={download.icon}>
												{download.label}
											</strong>
										</td>

										{(has_xls && download.xls.enabled) && (
											<td>
												<ButtonCollection _class={{other:'gui_flex_center'}}>
													{(download.xls.iso) && (
														<SquaredButton
															onClick={(utf8, csv) => onclick(download.url, false, false)}
															icon='knk-database'
															tooltip={<Tooltip
																with_icon={false}
																position="top"
															>Download to Excel file</Tooltip>}
															aria-label="Download to Excel file"
														/>
													)}

													{(download.xls.utf8) && (
														<SquaredButton
															onClick={(utf8, csv) => onclick(download.url, true, false)}
															icon='knk-database-utf8'
															tooltip={<Tooltip
																with_icon={false}
																position="top"
																autotranslate={false}
															>{`${i18n("Download to Excel file")}<br />(${i18n("UTF8 encoded")})`}</Tooltip>}
															aria-label="Download to Excel file UTF8 encoded"
														/>
													)}
												</ButtonCollection>
											</td>
										)}

										{(has_csv && download.csv.enabled) && (
											<td>
												<ButtonCollection _class={{other:'gui_flex_center'}}>
													{(download.csv.iso) && (
														<SquaredButton
															onClick={(utf8, csv) => onclick(download.url, false, true)}
															icon='knk-database'
															tooltip={<Tooltip
																with_icon={false}
																position="top"
															>Download to CSV file</Tooltip>}
															aria-label="Download to CSV file"
														/>
													)}

													{(download.csv.utf8) && (
														<SquaredButton
															onClick={(utf8, csv) => onclick(download.url, true, true)}
															icon='knk-database-utf8'
															tooltip={<Tooltip
																with_icon={false}
																position="top"
																autotranslate={false}
															>{`${i18n("Download to CSV file")}<br />(${i18n("UTF8 encoded")})`}</Tooltip>}
															aria-label="Download to CSV file UTF8 encoded"
														/>
													)}
												</ButtonCollection>
											</td>
										)}
									</tr>
								)}
							)}
						</tbody>
					</table>
				</div>
			</div>
		</FloatingLayer>
	)
};

export default injectIntl(DownloadFileOptions);